import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import {
  CardSkeleton,
  CardContainer,
  CardWrapper
} from './styles'

const Card = ({ children, full, loading = false, skeletonHeight, margin, padding, hasBorder = true }) => {
  return (
    <CardWrapper full={full} margin={margin}>
      {loading
        ? (
          <CardSkeleton full={full}>
            <Skeleton height={skeletonHeight ? `${skeletonHeight}px` : '100%'} />
          </CardSkeleton>
        )
        : (
          <CardContainer full={full} padding={padding} hasBorder={hasBorder}>
            {children}
          </CardContainer>
        )
      }
    </CardWrapper>
  )
}

export default Card
